<template>
  <div>

    <el-alert :title="scoreTitle" :description="scoreDesc" type="success" show-icon />

    <el-form class="form" size="mini" label-width="83px">
      <el-form-item label="显卡分类">
        <el-checkbox-group v-model="selectCateModel" size="mini">
          <el-checkbox :key="item.name" v-for="item in cateList" :label="item.name" size="mini" />
        </el-checkbox-group>
      </el-form-item>
    </el-form>

    <el-tabs class="tabs" v-model="activeTab" type="card" size="mini">
      <el-tab-pane label="按排名" name="byRank" size="mini">
        <gpu-benchmarks-by-rank
          :globalConfig="globalConfig"
          :selectCate="selectCate"
          :gpuBenchmarksList="gpuBenchmarks" />
      </el-tab-pane>

      <el-tab-pane label="按厂商" name="byCompany" size="mini">
        <gpu-benchmarks-by-company
          :globalConfig="globalConfig"
          :selectCate="selectCate"
          :gpuBenchmarksList="gpuBenchmarks" />
      </el-tab-pane>
    </el-tabs>

    <about-me :globalConfig="globalConfig" />

  </div>
</template>

<script>
import axios from 'axios'
import GpuBenchmarksByRank from './GpuBenchmarksByRank.vue'
import GpuBenchmarksByCompany from './GpuBenchmarksByCompany.vue'
import AboutMe from './AboutMe.vue'

export default {
  name: 'GpuBenchmarks',
  components: {
    GpuBenchmarksByRank,
    GpuBenchmarksByCompany,
    AboutMe
  },
  props: {
    globalConfig: Object
  },
  data () {
    return {
      loading: false,
      activeTab: 'byRank',

      scoreTitle: '分数基于 PassMark 制作',
      scoreDesc: '为便于记忆，以 RTX 3070 为 100 分。如 RX6600 为 67 分，RX6750GRE 为 84分，升级将带来 26%（67x1.26=84）的提升！',

      // form
      selectCateModel: ['NVIDIA', 'AMD', 'Intel'],

      // api
      cateList: [],
      gpuBenchmarks: []
    }
  },
  watch: {
    selectCateModel () {
      this.getGpuBenchmarks()
    }
  },
  computed: {
    selectCate () {
      return this.cateList.filter(v => this.selectCateModel.indexOf(v.name) >= 0)
    }
  },
  mounted () {
    this.getCateList()
    this.getGpuBenchmarks()
  },
  methods: {
    getCateList: async function () {
      const cateListResponse = await axios.get('/api/gpu/cate_list')
      const response = cateListResponse.data
      if (response.code === 0) {
        this.cateList = response.data.list
      }
    },
    getGpuBenchmarks: async function () {
      this.loading = true
      try {
        const gpuBenchmarksResponse = await axios.post('/api/gpu/benchmarks', { cate: this.selectCateList })
        const response = gpuBenchmarksResponse.data
        if (response.code === 0) {
          this.gpuBenchmarks = response.data.list
          this.$message({ message: '显卡天梯图数据加载成功', type: 'success', duration: 1000 })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.form {
  padding-top: 10px;
}
.tabs {
  margin-top: -10px;
}
</style>
